import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_USER_DASHBOARD } from '../routes/paths';
import { USER_ROLES } from 'src/constants/keywords';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return (
      <Navigate
        to={user?.role === USER_ROLES.ADMIN ? PATH_DASHBOARD.root : PATH_USER_DASHBOARD.root}
      />
    );
  }

  return <>{children}</>;
}
